import { render, staticRenderFns } from "./MessagesTable.vue?vue&type=template&id=6f91eaf2&scoped=true&"
import script from "./MessagesTable.vue?vue&type=script&lang=ts&"
export * from "./MessagesTable.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesTable.vue?vue&type=style&index=0&id=6f91eaf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f91eaf2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f91eaf2')) {
      api.createRecord('6f91eaf2', component.options)
    } else {
      api.reload('6f91eaf2', component.options)
    }
    module.hot.accept("./MessagesTable.vue?vue&type=template&id=6f91eaf2&scoped=true&", function () {
      api.rerender('6f91eaf2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_messages/components/MessagesTable.vue"
export default component.exports